module.exports = __webpack_public_path__ + "static/img/rule.3d3aa7df.svg";